module.exports = __webpack_public_path__ + "img/scroll-to-top.8e1458c6.svg";